import { pushOrSplice } from './functions'
import { TOKEN_TYPE } from './tokens'
import tokenizer from './tokenizer'
import compiler from './compiler'
import FronthubError from '../../../../core/helpers/FronthubError'

export default (tokens, permissions, context) => {
  let remove = false

  const grammar = {
    [TOKEN_TYPE.NOT]: () => {
      remove = true
    },
    [TOKEN_TYPE.RESOURCE]: () => {},
    [TOKEN_TYPE.EXTENDS]: idx => {
      if (!tokens[idx + 1] || tokens[idx + 1].type !== TOKEN_TYPE.ROLE) {
        throw new FronthubError('rbac you can only extends roles')
      }
    },
    [TOKEN_TYPE.PERMISSION]: idx => {
      const token = tokens[idx]
      const permission = tokens[idx - 1].value + ':' + token.value
      pushOrSplice(remove, permissions, permission)
    },
    [TOKEN_TYPE.PERMIT_ALL]: idx => {
      const resourceName = tokens[idx - 1].value
      const resource = context.permissions[resourceName]
      if (!Array.isArray(resource)) {
        throw new FronthubError(
          'rbac resources ' +
            resourceName +
            ' was not found or must be an array',
        )
      }

      resource
        .map(perm => tokens[idx - 1].value + ':' + perm)
        .forEach(perm => {
          pushOrSplice(remove, permissions, perm)
        })
    },
    [TOKEN_TYPE.ROLE]: idx => {
      const token = tokens[idx]
      const grantName = token.value
      const grant = context.grants[grantName]
      if (!Array.isArray(grant)) {
        throw new FronthubError(
          'rbac grants ' + grantName + ' must be an array',
        )
      }
      grant.forEach(grant => {
        const role_tokens = tokenizer(grant)
        compiler(role_tokens, permissions, context)
      })
    },
  }

  tokens.forEach((lexical, idx) => {
    if (!grammar[lexical.type])
      throw new FronthubError('rbac undefined token ' + lexical.type)
    grammar[lexical.type](idx)
  })

  return permissions
}
